import Field from './Field';
import { inputClass } from './styles';

interface SoftLimitFieldProps {
  value: string;
  onChange: (v: string) => void;
  error: string | null;
  placeholder: string;
  help: string;
  disabled?: boolean;
}

export default function SoftLimitField({
  value,
  onChange,
  error,
  placeholder,
  help,
  disabled,
}: SoftLimitFieldProps) {
  return (
    <Field
      label="Soft limit"
      htmlFor="softLimit"
      error={value.length > 0 ? error : null}
      help={help}
    >
      <input
        id="softLimit"
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={inputClass(value.length > 0 && !!error)}
        disabled={disabled}
      />
    </Field>
  );
}
